
document.addEventListener("DOMContentLoaded", function() {
  // Add smooth scrolling to all links with hash targets
  var links = document.querySelectorAll("a[data-scrolling]");
  
  links.forEach(function(link) {
    link.addEventListener("click", function(event) {
      var targetUrl = this.getAttribute('href'); // Get the href attribute of the clicked link
        console.log(targetUrl);
      if (targetUrl && targetUrl !== "#") {
        event.preventDefault();

        // Using native JavaScript to animate scrolling to the target element
        var targetElement = document.querySelector(targetUrl);
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: "smooth"
          });

          // Update the URL without adding a history entry (remove the hash)
          // history.replaceState(null, null, targetUrl);
        }
      }
    });
  });

//   window.onbeforeunload = function () {
//   window.scrollTo(0, 0);
// }
});


